module.exports = __webpack_public_path__ + "img/Logo-login.49c793cc.svg";